import { oneLinkUrl, utmParams } from "../shared/links";
import { getHostel, HOSTELS, type Trip } from "./content";

/** The OneLink behind every "Get Stippl" button; `c` says which button it was. */
export const appUrl = (c: string): string => oneLinkUrl("madmonkey", `mm_${c}`);

const MM_UTM = utmParams("stippl", "mm_page");

export const MM_HOME_URL = `https://madmonkeyhostels.com/?${MM_UTM}`;

/** A hostel's page on madmonkeyhostels.com. */
export const mmUrl = (slug: string): string => `${HOSTELS[slug].url}?${MM_UTM}`;

/**
 * Any link to madmonkeyhostels.com, with the same utm as `mmUrl`: a booking, an event or a next stop the knowledge base names.
 * A link to anywhere else (Google Maps, a social) stays as it is, and so does one that has a `utm_source` already.
 */
export const mmLink = (url: string): string => {
	let host: string;
	try {
		host = new URL(url).hostname;
	} catch {
		return url;
	}
	if (!/(^|\.)madmonkeyhostels\.com$/.test(host) || url.includes("utm_source=")) return url;
	const [path, hash] = url.split("#");
	return `${path}${path.includes("?") ? "&" : "?"}${MM_UTM}${hash === undefined ? "" : `#${hash}`}`;
};

/** The page of one of our own routes. The route cards no longer open it (`routePreviewHref`); it stays for the link from its own page. */
export const tripPath = (id: string): string => `/mad-monkey/routes/${id}`;

/**
 * What a route card opens: the route as the app's own preview of the synced trip. A plain `<a>`, not a router `Link`: the
 * preview is an app route that the marketing router does not know, so it needs a page load.
 */
export const routePreviewHref = (trip: Pick<Trip, "tripId">): string => `/routepreview/${trip.tripId}?${utmParams("madmonkey", "mm_route")}`;
export const hostelPath = (slug: string): string => `/mad-monkey/hostels/${slug}`;
export const HOME_PATH = "/mad-monkey";

/** "Start a route here" for a visitor on a page framed on another site: it opens a tab of its own, which cannot be handed `location.state`, so the hostel is in the address. */
export const startPath = (slug: string): string => `${HOME_PATH}?hostel=${slug}#hostels`;

/** The hostel `?hostel=<slug>` names, when it is one of ours: anything else in the address is ignored. */
export const hostelOfSearch = (search: string): string | null => {
	const slug = new URLSearchParams(search).get("hostel") ?? "";
	return getHostel(slug) ? slug : null;
};
